import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AuditsState } from './audits.reducer';
import { selectSelectedLocationId } from '../ui';

export const selectAuditsFeature = createFeatureSelector<AuditsState>('audits');

export const selectReports = createSelector(selectAuditsFeature, selectSelectedLocationId, (state, locationId) =>
  locationId === null ? null : state.reports[locationId],
);

export const selectShouldLoadReports = createSelector(
  selectAuditsFeature,
  selectSelectedLocationId,
  (state, locationId) => locationId !== null && !state.reports[locationId] && !state.loadingLocations.includes(locationId),
);

export const selectIsLoading = createSelector(selectAuditsFeature, selectSelectedLocationId, (state, locationId) =>
  locationId === null ? false : state.loadingLocations.includes(locationId),
);

export const selectCardLayout = createSelector(selectAuditsFeature, state => state.layout);
